(function() {
	angular
		.module('ShargoApp')
		.controller('DriverFormController',function ($filter, $rootScope, $timeout, $anchorScroll, $http, $scope, $window, _, Configuration, toolsService, Analytics) {
			$rootScope.pageConfiguration = {
				footer: true,
				header: {
					solid: -1000,
					background: 'linear-gradient(to bottom, #fed256, #ffbd4d)',
					preheader: false,
					headerLink: $rootScope.url('home'),
					headerLogo: $rootScope.device.isDesktop ? Configuration.siteDomain + "/img/header/shargo-white.svg" : Configuration.siteDomain + "/img/header/shargo-mobile.svg",
					logIn: false,
					dashboard: false,
					callToAction: {
						link: false,
						text: '',
						target: '',
						hide: false,
						disabled: false
					},
					profile: false
				}
			};

			/* --VARIABLES-- */
			$scope.districtSelected = $scope.formSent = $scope.selectDistrict = $scope.uploadingDriverForm = false;
			var selectDistrictForced = false;

			var params = {
				firstName: "",
				lastName: "",
				email: "",
				phone: "",
				age: "",
				city: "",
				neighbourhood: "",
				workPermision: 0, //Number? 0 -> false | 1 -> true ?
				currentWork: "", //enum: ['student', 'half_time', 'full_time', 'per_hours', 'unemployed']
				selfEmployed: "", //enum: ['yes', 'yes_cooperative', 'dont_want', 'could_be']
				transport: [], //0,1,2,3,4
				smartPhone: "", //enum: ['ios_new', 'android_new', 'old_version', 'other']
				areYouCourier: "", //enum: ['yes_food', 'yes_logistics', 'yes_other', 'no']
				haveYouBeenCourier: "", //enum: ['yes_food', 'yes_logistics', 'yes_other', 'no']
				availability: [],//type: [], /// [[0,2,3],[1,2],[0]]  1rst array monday-friday 2nd array saturday 3rd array sunday. Numbers 0 -> morning, 1 -> lunch time, 2 -> afternoon, 3 -> night
				comments: "",
				hearAboutUs: "", //enum: ['mouth_ear', 'social_net', 'web', 'job_site', 'other']
				imageData: ""
			};
			$scope.pages = {
				current: 0,
				total: 0
			};
			$scope.section = {
				title: "",
				others: ""
			};
			$scope.selectForm = [];
			$scope.city = {
				function: selectDistrictFunction,
				districts: []
			};
			$scope.errors = {};

			var barcelonaDistricts = [
				{"selected": false, "placeholder": "Ciutat Vella"},
				{"selected": false, "placeholder": "Eixample"},
				{"selected": false, "placeholder": "Gràcia"},
				{"selected": false, "placeholder": "Sants-Montjuic"},
				{"selected": false, "placeholder": "Les Corts"},
				{"selected": false, "placeholder": "Sarrià-Sant Gervasi"},
				{"selected": false, "placeholder": "Horta-Guinardó"},
				{"selected": false, "placeholder": "Nou Barris"},
				{"selected": false, "placeholder": "Sant Andreu"},
				{"selected": false, "placeholder": "Sant Martí"},
				{"selected": false, "placeholder": "Sant Cugat y Alrededores"},
				{"selected": false, "placeholder": "Àrea metropolitana"}
			];

            var zaragozaDistricts = [
                {"selected": false, "placeholder": "Zaragoza"}
            ];

			var valenciaDistricts = [
				{"selected": false, "placeholder": "Valencia"}
			];

			var tenerifeDistricts = [
				{"selected": false, "placeholder": "Tenerife"}
			];

			var murciaDistricts = [
				{"selected": false, "placeholder": "Murcia"}
			];

			var avilesDistricts = [
				{"selected": false, "placeholder": "Avilés"}
			];
			var gijonDistricts = [
				{"selected": false, "placeholder": "Gijón"}
			];
			var ejidoDistricts = [
				{"selected": false, "placeholder": "Ejido"}
			];
			var jaenDistricts = [
				{"selected": false, "placeholder": "Jaén"}
			];
			var palmaDeMallorcaDistricts = [
				{"selected": false, "placeholder": "Palma de Mallorca"}
			];
			var valladolidDistricts = [
				{"selected": false, "placeholder": "Valladolid"}
			];
			var albaceteDistricts = [
				{"selected": false, "placeholder": "Albacete"}
			];
			var alicanteDistricts = [
				{"selected": false, "placeholder": "Alicante"}
			];
			var salamancaDistricts = [
				{"selected": false, "placeholder": "Salamanca"}
			];
			var talaveraDeLaReinaDistricts = [
				{"selected": false, "placeholder": "Talavera de la Reina"}
			];
			var laspalmasDistricts = [
				{"selected": false, "placeholder": "Las Palmas"}
			];
			var elcheDistricts = [
				{"selected": false, "placeholder": "Elche"}
			];

			var madridDistricts = [
				{"selected": false, "placeholder": "Centro"},
				{"selected": false, "placeholder": "Arganzuela"},
				{"selected": false, "placeholder": "Retiro"},
				{"selected": false, "placeholder": "Salamanca"},
				{"selected": false, "placeholder": "Chamartín"},
				{"selected": false, "placeholder": "Tetuán"},
				{"selected": false, "placeholder": "Chamberí"},
				{"selected": false, "placeholder": "Fuencarral-El Pardo"},
				{"selected": false, "placeholder": "Moncloa-Aravaca"},
				{"selected": false, "placeholder": "Latina"},
				{"selected": false, "placeholder": "Carabanchel"},
				{"selected": false, "placeholder": "Usera"},
				{"selected": false, "placeholder": "Puente de Vallecas"},
				{"selected": false, "placeholder": "Moratalaz"},
				{"selected": false, "placeholder": "Ciudad Lineal"},
				{"selected": false, "placeholder": "Hortaleza"},
				{"selected": false, "placeholder": "Villaverde"},
				{"selected": false, "placeholder": "Villa de Vallecas"},
				{"selected": false, "placeholder": "Vicálvaro"},
				{"selected": false, "placeholder": "San Blas-Canillejas"}
			];

			var badalonaDistricts = [
				{"selected": false, "placeholder": "Badalona"},
				{"selected": false, "placeholder": "Santa Coloma"},
				{"selected": false, "placeholder": "Sant Adrià"}
			];

			function compare(a,b) {
				var p = a.placeholder.replace(new RegExp(/[Àáâãäå]/g),"A");
				var t = b.placeholder.replace(new RegExp(/[Àáâãäå]/g),"A");
				if (p < t) return -1;
				else return 1;
			}

			barcelonaDistricts.sort(compare);
			madridDistricts.sort(compare);

			var sections = [
				{title: "driver-form.sections.title-1", others: ""},
				{title: "driver-form.sections.title-2", others: ""},
				{title: "driver-form.sections.title-2", others: ""},
				{title: "driver-form.sections.title-3", others: "driver-form.sections.others-3"},
				{title: "driver-form.sections.title-4", others: "driver-form.sections.others-4"},
				{title: "driver-form.sections.title-5", others: ""}
			];

			$scope.imageProfile = false;
			$scope.personalInfo = {
				"name": {"selected": false, "model": ""},
				"surnames": {"selected": false, "model": ""},
				"email": {"selected": false, "model": ""},
				"phone": {"selected": false, "model": ""},
				"age": {"selected": false, "model": ""}
			};
			$scope.residence = {
				"barcelona": {
					"selected": false, 
					"model": "", 
					"fullName": "Barcelona", 
					"districts": barcelonaDistricts
        		},
       			"badalona": {
						"selected": false, "model": "", "fullName": "Badalona", districts: badalonaDistricts
					},
				"madrid": {
					"selected": false, "model": "", "fullName": "Madrid", districts: madridDistricts
				},
				"zaragoza": {
					"selected": false, "model": "", "fullName": "Zaragoza", districts: zaragozaDistricts
				},
				"valencia": {
					"selected": false, "model": "", "fullName": "Valencia", districts: valenciaDistricts
				},
				"laspalmas": {
					"selected": false, "model": "", "fullName": "Las Palmas", districts: laspalmasDistricts
				},
				"tenerife": {
					"selected": false, "model": "", "fullName": "Tenerife", districts: tenerifeDistricts
				},
				"murcia": {
					"selected": false, "model": "", "fullName": "Murcia", districts: murciaDistricts
				},
				"aviles": {
					"selected": false, "model": "", "fullName": "Aviles", districts: avilesDistricts
				},
				"gijon": {
					"selected": false, "model": "", "fullName": "Gijon", districts: gijonDistricts
				},
				"ejido": {
					"selected": false, "model": "", "fullName": "Ejido", districts: ejidoDistricts
				},
				"jaen": {
					"selected": false, "model": "", "fullName": "Jaen", districts: jaenDistricts
				},
				"palmaDeMallorca": {
					"selected": false, "model": "", "fullName": "Palma de Mallorca", districts: palmaDeMallorcaDistricts
				},
				"valladolid": {
					"selected": false, "model": "", "fullName": "Valladolid", districts: valladolidDistricts
				},
				"albacete": {
					"selected": false, "model": "", "fullName": "Albacete", districts: albaceteDistricts
				},
				"alicante": {
					"selected": false, "model": "", "fullName": "Alicante", districts: alicanteDistricts
				},
				"salamanca": {
					"selected": false, "model": "", "fullName": "Salamanca", districts: salamancaDistricts
				},
				"talaveraDeLaReina": {
					"selected": false, "model": "", "fullName": "Talavera de la Reina", districts: talaveraDeLaReinaDistricts
				},
				"elche": {
					"selected": false, "model": "", "fullName": "Elche", districts: elcheDistricts
				}
			};
			$scope.workPermission = {
				"yes": {"selected": false, "model": ""},
				"no": {"selected": false, "model": ""}
			};
			$scope.currentWork = {
				"student": {"selected": false, "model": ""},
				"full-time": {"selected": false, "model": ""},
				"half-time": {"selected": false, "model": ""},
				"hour": {"selected": false, "model": ""},
				"unemployed": {"selected": false, "model": ""}
			};
			$scope.freelance = {
				"yes1": {"selected": false, "model": ""},
				"yes2": {"selected": false, "model": ""},
				"no1": {"selected": false, "model": ""},
				"no2": {"selected": false, "model": ""}
			};
			$scope.vehicle = {
				"bike": {"selected": false, "model": ""},
				"moto": {"selected": false, "model": ""},
				"car": {"selected": false, "model": ""},
				"van": {"selected": false, "model": ""},
				"none": {"selected": false, "model": ""}
			};
			$scope.smartphone = {
				"android": {"selected": false, "model": ""},
				"ios": {"selected": false, "model": ""},
				//"old": {"selected": false, "model": ""},
				"other": {"selected": false, "model": ""}
			};
			$scope.currentDeliver = {
				"yes-food": {"selected": false, "model": ""},
				"yes-traditional": {"selected": false, "model": ""},
				"yes": {"selected": false, "model": ""},
				"no": {"selected": false, "model": ""}
			};
			$scope.pastDeliver = {
				"yes-food": {"selected": false, "model": ""},
				"yes-traditional": {"selected": false, "model": ""},
				"yes": {"selected": false, "model": ""},
				"no": {"selected": false, "model": ""}
			};
			$scope.weekday = {
				"morning": {"selected": false, "model": ""},
				"midday": {"selected": false, "model": ""},
				"evening": {"selected": false, "model": ""},
				"night": {"selected": false, "model": ""}
			};
			$scope.saturday = {
				"morning": {"selected": false, "model": ""},
				"midday": {"selected": false, "model": ""},
				"evening": {"selected": false, "model": ""},
				"night": {"selected": false, "model": ""}
			};
			$scope.sunday = {
				"morning": {"selected": false, "model": ""}
			};
			$scope.comments = {
				"message": {"selected": false, "model": ""}
			};
			$scope.howFindUs = {
				"mouth-ear": {"selected": false, "model": ""},
				"social-networks": {"selected": false, "model": ""},
				"web": {"selected": false, "model": ""},
				"employment": {"selected": false, "model": ""},
				"job_today": {"selected": false, "model": ""},
				"corner_job": {"selected": false, "model": ""},
				"others": {"selected": false, "model": ""}
			};
			$scope.terms = {
				"yes": {"selected": false, "model": ""}
			};

			var defaultBundleForm = {
				"title": "",
				"others": "",
				"class": "input-radio",
				"extra": "<div></div>",
				"line": true,
				"contenteditable": false,
				"function": selectRadio,
				"params": [false],
				"data": "",
				"inputs": []
			};
			var defaultBundleInputs = {
				"class": "",
				"line": "",
				"contenteditable": "",
				"model": "",
				"extra": "",
				"id": "",
				"placeholder": ""
			};

			//1.1
			var inputPersonalInfo = _.clone(defaultBundleForm);
			inputPersonalInfo.class = "input-text";
			inputPersonalInfo.extra = "<div class='alert'></div>";
			inputPersonalInfo.line = false;
			inputPersonalInfo.contenteditable = true;
			inputPersonalInfo.function = doNothing;
			inputPersonalInfo.params = [];
			inputPersonalInfo.data = $scope.personalInfo;

			var inputPersonalInfo1 = _.clone(defaultBundleInputs);
			inputPersonalInfo1.id = "name";
			inputPersonalInfo1.placeholder = 'driver-form.personal-info.name';
			inputPersonalInfo1.type = "text";
			var inputPersonalInfo2 = _.clone(defaultBundleInputs);
			inputPersonalInfo2.id = "surnames";
			inputPersonalInfo2.placeholder = 'driver-form.personal-info.surnames';
			inputPersonalInfo2.type = "text";
			var inputPersonalInfo3 = _.clone(defaultBundleInputs);
			inputPersonalInfo3.id = "email";
			inputPersonalInfo3.placeholder = 'driver-form.personal-info.email';
			inputPersonalInfo3.type = "email";
			var inputPersonalInfo4 = _.clone(defaultBundleInputs);
			inputPersonalInfo4.id = "phone";
			inputPersonalInfo4.placeholder = 'driver-form.personal-info.phone';
			inputPersonalInfo4.type = "text";
			var inputPersonalInfo5 = _.clone(defaultBundleInputs);
			inputPersonalInfo5.id = "age";
			inputPersonalInfo5.placeholder = 'driver-form.personal-info.age';
			inputPersonalInfo5.type = "text";

			inputPersonalInfo.inputs = [
				inputPersonalInfo1,
				inputPersonalInfo2,
				inputPersonalInfo3,
				inputPersonalInfo4,
				inputPersonalInfo5
			];

			$scope.inputForm = inputPersonalInfo;


			//1.2
      var selectResidence = _.clone(defaultBundleForm);
      selectResidence.title = 'driver-form.residence.title';
      selectResidence.data = $scope.residence;
      selectResidence.function = selectCity;

			selectResidence.inputs = [];
			
			var citiesToUse = Object.keys($scope.residence);
			for (var i = 0; i < citiesToUse.length; ++i) {
				var tempItem = _.clone(defaultBundleInputs);
				tempItem.id = citiesToUse[i];
				tempItem.placeholder = 'driver-form.residence.'+citiesToUse[i];
				selectResidence.inputs.push(_.clone(tempItem));
			}
			
			//2.2
			var selectWorkPermission = _.clone(defaultBundleForm);
			selectWorkPermission.title = 'driver-form.work-permission.title';
			selectWorkPermission.data = $scope.workPermission;

			var selectWorkPermission1 = _.clone(defaultBundleInputs);
			selectWorkPermission1.id = "yes";
			selectWorkPermission1.placeholder = 'driver-form.work-permission.yes';
			var selectWorkPermission2 = _.clone(defaultBundleInputs);
			selectWorkPermission2.id = "no";
			selectWorkPermission2.placeholder = 'driver-form.work-permission.no';

			selectWorkPermission.inputs = [
				selectWorkPermission1,
				selectWorkPermission2
			];


			//2.3
			var selectCurrentWork = _.clone(defaultBundleForm);
			selectCurrentWork.title = 'driver-form.current-work.title';
			selectCurrentWork.data = $scope.currentWork;

			var selectCurrentWork1 = _.clone(defaultBundleInputs);
			selectCurrentWork1.id = "student";
			selectCurrentWork1.placeholder = 'driver-form.current-work.option-1';
			var selectCurrentWork2 = _.clone(defaultBundleInputs);
			selectCurrentWork2.id = "full-time";
			selectCurrentWork2.placeholder = 'driver-form.current-work.option-2';
			var selectCurrentWork3 = _.clone(defaultBundleInputs);
			selectCurrentWork3.id = "half-time";
			selectCurrentWork3.placeholder = 'driver-form.current-work.option-3';
			var selectCurrentWork4 = _.clone(defaultBundleInputs);
			selectCurrentWork4.id = "hour";
			selectCurrentWork4.placeholder = 'driver-form.current-work.option-4';
			var selectCurrentWork5 = _.clone(defaultBundleInputs);
			selectCurrentWork5.id = "unemployed";
			selectCurrentWork5.placeholder = 'driver-form.current-work.option-5';

			selectCurrentWork.inputs = [
				selectCurrentWork1,
				selectCurrentWork2,
				selectCurrentWork3,
				selectCurrentWork4,
				selectCurrentWork5
			];


			//2.4
			var selectFreelance = _.clone(defaultBundleForm);
			selectFreelance.title = 'driver-form.freelance.title';
			selectFreelance.data = $scope.freelance;

			var selectFreelance1 = _.clone(defaultBundleInputs);
			selectFreelance1.id = "yes1";
			selectFreelance1.placeholder = 'driver-form.freelance.option-1';
			var selectFreelance2 = _.clone(defaultBundleInputs);
			selectFreelance2.id = "yes2";
			selectFreelance2.placeholder = 'driver-form.freelance.option-2';
			var selectFreelance3 = _.clone(defaultBundleInputs);
			selectFreelance3.id = "no1";
			selectFreelance3.placeholder = 'driver-form.freelance.option-3';
			var selectFreelance4 = _.clone(defaultBundleInputs);
			selectFreelance4.id = "no2";
			selectFreelance4.placeholder = 'driver-form.freelance.option-4';
			selectFreelance4.extra = 'driver-form.freelance.others-4';

			selectFreelance.inputs = [
				selectFreelance1,
				selectFreelance2,
				selectFreelance3,
				selectFreelance4
			];


			//3.1
			var selectVehicle = _.clone(defaultBundleForm);

			selectVehicle.title = 'driver-form.vehicle.title';
			selectVehicle.others = 'driver-form.vehicle.others';
			selectVehicle.params = [true];
			selectVehicle.data = $scope.vehicle;

			var selectVehicle1 = _.clone(defaultBundleInputs);
			selectVehicle1.id = "bike";
			selectVehicle1.placeholder = 'driver-form.vehicle.option-1';
			var selectVehicle2 = _.clone(defaultBundleInputs);
			selectVehicle2.id = "moto";
			selectVehicle2.placeholder = 'driver-form.vehicle.option-2';
			var selectVehicle3 = _.clone(defaultBundleInputs);
			selectVehicle3.id = "car";
			selectVehicle3.placeholder = 'driver-form.vehicle.option-3';
			var selectVehicle4 = _.clone(defaultBundleInputs);
			selectVehicle4.id = "van";
			selectVehicle4.placeholder = 'driver-form.vehicle.option-4';
			var selectVehicle5 = _.clone(defaultBundleInputs);
			selectVehicle5.id = "none";
			selectVehicle5.placeholder = 'driver-form.vehicle.option-5';

			selectVehicle.inputs = [
				selectVehicle1,
				selectVehicle2,
				selectVehicle3,
				selectVehicle4,
				selectVehicle5
			];


			//3.2
			var selectSmartphone = _.clone(defaultBundleForm);
			selectSmartphone.title = 'driver-form.smartphone.title';
			selectSmartphone.data = $scope.smartphone;

			var selectSmartphone1 = _.clone(defaultBundleInputs);
			selectSmartphone1.id = "android";
			selectSmartphone1.placeholder = 'driver-form.smartphone.option-1';
			var selectSmartphone2 = _.clone(defaultBundleInputs);
			selectSmartphone2.id = "ios";
			selectSmartphone2.placeholder = 'driver-form.smartphone.option-2';
			var selectSmartphone3 = _.clone(defaultBundleInputs);
			selectSmartphone3.id = "old";
			selectSmartphone3.placeholder = 'driver-form.smartphone.option-3';
			var selectSmartphone4 = _.clone(defaultBundleInputs);
			selectSmartphone4.id = "other";
			selectSmartphone4.placeholder = 'driver-form.smartphone.option-4';

			selectSmartphone.inputs = [
				selectSmartphone1,
				selectSmartphone2,
				//selectSmartphone3,
				selectSmartphone4
			];


			//3.3
			var selectCurrentDeliver = _.clone(defaultBundleForm);
			selectCurrentDeliver.title = 'driver-form.deliver.title-1';
			selectCurrentDeliver.data = $scope.currentDeliver;

			var selectCurrentDeliver1 = _.clone(defaultBundleInputs);
			selectCurrentDeliver1.id = "yes-food";
			selectCurrentDeliver1.placeholder = 'driver-form.deliver.option-1';
			var selectCurrentDeliver2 = _.clone(defaultBundleInputs);
			selectCurrentDeliver2.id = "yes-traditional";
			selectCurrentDeliver2.placeholder = 'driver-form.deliver.option-2';
			var selectCurrentDeliver3 = _.clone(defaultBundleInputs);
			selectCurrentDeliver3.id = "yes";
			selectCurrentDeliver3.placeholder = 'driver-form.deliver.option-3';
			var selectCurrentDeliver4 = _.clone(defaultBundleInputs);
			selectCurrentDeliver4.id = "no";
			selectCurrentDeliver4.placeholder = 'driver-form.deliver.option-4';

			selectCurrentDeliver.inputs = [
				selectCurrentDeliver1,
				selectCurrentDeliver2,
				selectCurrentDeliver3,
				selectCurrentDeliver4
			];

			//3.4
			var selectPastDeliver = _.clone(defaultBundleForm);
			selectPastDeliver.title = 'driver-form.deliver.title-2';
			selectPastDeliver.data = $scope.pastDeliver;

			var selectPastDeliver1 = _.clone(defaultBundleInputs);
			selectPastDeliver1.id = "yes-food";
			selectPastDeliver1.placeholder = 'driver-form.deliver.option-1';
			var selectPastDeliver2 = _.clone(defaultBundleInputs);
			selectPastDeliver2.id = "yes-traditional";
			selectPastDeliver2.placeholder = 'driver-form.deliver.option-2';
			var selectPastDeliver3 = _.clone(defaultBundleInputs);
			selectPastDeliver3.id = "yes";
			selectPastDeliver3.placeholder = 'driver-form.deliver.option-3';
			var selectPastDeliver4 = _.clone(defaultBundleInputs);
			selectPastDeliver4.id = "no";
			selectPastDeliver4.placeholder = 'driver-form.deliver.option-5';

			selectPastDeliver.inputs = [
				selectPastDeliver1,
				selectPastDeliver2,
				selectPastDeliver3,
				selectPastDeliver4
			];


			//4.1
			var selectWeekday = _.clone(defaultBundleForm);
			selectWeekday.title = 'driver-form.disponibility.title-1';
			selectWeekday.data = $scope.weekday;
			selectWeekday.params = [true];

			var selectWeekday1 = _.clone(defaultBundleInputs);
			selectWeekday1.id = "morning";
			selectWeekday1.placeholder = 'driver-form.disponibility.option-1';
			var selectWeekday2 = _.clone(defaultBundleInputs);
			selectWeekday2.id = "midday";
			selectWeekday2.placeholder = 'driver-form.disponibility.option-2';
			var selectWeekday3 = _.clone(defaultBundleInputs);
			selectWeekday3.id = "evening";
			selectWeekday3.placeholder = 'driver-form.disponibility.option-3';
			var selectWeekday4 = _.clone(defaultBundleInputs);
			selectWeekday4.id = "night";
			selectWeekday4.placeholder = 'driver-form.disponibility.option-4';

			selectWeekday.inputs = [
				selectWeekday1,
				selectWeekday2,
				selectWeekday3,
				selectWeekday4
			];


			//4.2
			var selectSaturday = _.clone(defaultBundleForm);
			selectSaturday.title = 'driver-form.disponibility.title-2';
			selectSaturday.data = $scope.saturday;
			selectSaturday.params = [true];

			var selectSaturday1 = _.clone(defaultBundleInputs);
			selectSaturday1.id = "morning";
			selectSaturday1.placeholder = 'driver-form.disponibility.option-1';
			var selectSaturday2 = _.clone(defaultBundleInputs);
			selectSaturday2.id = "midday";
			selectSaturday2.placeholder = 'driver-form.disponibility.option-2';
			var selectSaturday3 = _.clone(defaultBundleInputs);
			selectSaturday3.id = "evening";
			selectSaturday3.placeholder = 'driver-form.disponibility.option-3';
			var selectSaturday4 = _.clone(defaultBundleInputs);
			selectSaturday4.id = "night";
			selectSaturday4.placeholder = 'driver-form.disponibility.option-4';

			selectSaturday.inputs = [
				selectSaturday1,
				selectSaturday2,
				selectSaturday3,
				selectSaturday4
			];


			//4.3
			var selectSunday = _.clone(defaultBundleForm);
			selectSunday.title = 'driver-form.disponibility.title-3';
			selectSunday.data = $scope.sunday;
			selectSunday.params = [true];

			var selectSunday1 = _.clone(defaultBundleInputs);
			selectSunday1.id = "morning";
			selectSunday1.placeholder = 'driver-form.disponibility.option-1';

			selectSunday.inputs = [
				selectSunday1
			];


			//5.2
			var selectHowFindUs = _.clone(defaultBundleForm);
			selectHowFindUs.title = 'driver-form.how-find-us.title';
			selectHowFindUs.data = $scope.howFindUs;

			var selectHowFindUs1 = _.clone(defaultBundleInputs);
			selectHowFindUs1.id = "mouth-ear";
			selectHowFindUs1.placeholder = 'driver-form.how-find-us.option-1';

			var selectHowFindUs2 = _.clone(defaultBundleInputs);
			selectHowFindUs2.id = "social-networks";
			selectHowFindUs2.placeholder = 'driver-form.how-find-us.option-2';

			var selectHowFindUs3 = _.clone(defaultBundleInputs);
			selectHowFindUs3.id = "web";
			selectHowFindUs3.placeholder = "Web";

			var selectHowFindUs4 = _.clone(defaultBundleInputs);
			selectHowFindUs4.id = "employment";
			selectHowFindUs4.placeholder = 'driver-form.how-find-us.option-3';

            var selectHowFindUs5 = _.clone(defaultBundleInputs);
            selectHowFindUs5.id = "job_today";
            selectHowFindUs5.placeholder = 'driver-form.how-find-us.option-5';

            var selectHowFindUs6 = _.clone(defaultBundleInputs);
            selectHowFindUs6.id = "corner_job";
            selectHowFindUs6.placeholder = 'driver-form.how-find-us.option-6';

			var selectHowFindUs7 = _.clone(defaultBundleInputs);
			selectHowFindUs7.id = "others";
			selectHowFindUs7.placeholder = 'driver-form.how-find-us.option-4';


			selectHowFindUs.inputs = [
				selectHowFindUs1,
				selectHowFindUs2,
				selectHowFindUs3,
				selectHowFindUs5,
				selectHowFindUs6,
                selectHowFindUs4,
				selectHowFindUs7
			];
			console.log("HowFindUs ->", selectHowFindUs.inputs);

			//6.1
			var selectTerms = _.clone(defaultBundleForm);
			selectTerms.title = 'driver-form.terms.title';
			selectTerms.data = $scope.terms;

			var selectTerms1 = _.clone(defaultBundleInputs);
			selectTerms1.id = "yes";
			selectTerms1.placeholder = 'driver-form.terms.option';

			selectTerms.inputs = [selectTerms1];


			var selectForms = [
				//1
				[selectResidence],
				//2
				[selectWorkPermission, selectCurrentWork, selectFreelance],
				//3
				[selectVehicle, selectSmartphone, selectCurrentDeliver, selectPastDeliver],
				//4
				[selectWeekday, selectSaturday, selectSunday],
				//5
				[selectHowFindUs],
				//6
				[selectTerms]
			];

			$scope.selectPage = selectPage;
			$scope.chooseFunction = chooseFunction;
			$scope.validateSelector = validateSelector;
			$scope.someEmpty = someEmpty;
			$scope.closeDistricts = closeDistricts;


			/* --FUNCTIONS-- */

			function selectPage(page) {
				if (page === $scope.pages.total + 1) {
					$scope.uploadingDriverForm = true;
					console.log('uploading driverForm')
					params.firstName = $scope.personalInfo.name.model;
					params.lastName = $scope.personalInfo.surnames.model;
					params.email = $scope.personalInfo.email.model;
					params.phone = $scope.personalInfo.phone.model;
					params.age = $scope.personalInfo.age.model;
					params.comments = $scope.comments.message.model;
					params.imageData = $scope.imageProfile.base64;

					var cityKeys = Object.keys($scope.residence);
					for (var i = 0; i < cityKeys.length; ++i ) {
						var actualCity = cityKeys[i];
						if ($scope.residence[actualCity].selected) {
							params.city = $scope.residence[actualCity].fullName;
							params.neighbourhood = $scope.residence[actualCity].districts[0].placeholder;
							for (var j = 0; j < $scope.residence[actualCity].districts.length && !params.neighbourhood; ++j) {
							  if ($scope.residence[actualCity].districts[j].selected) {
								  params.neighbourhood = $scope.residence[actualCity].districts[j].placeholder;
							  }
							}
						}
					}
					for (var i in $scope.workPermission) {
						if($scope.workPermission[i].selected) {
							params.workPermision = i === 'no' ? 0 : 1;
						}
					}
					for (var i in $scope.currentWork) {
						if($scope.currentWork[i].selected) {
							if (i === "student") {
								params.currentWork = 'student';
							}
							else if (i === "full-time") {
								params.currentWork = 'full_time';
							}
							else if (i === "half-time") {
								params.currentWork = 'half_time';
							}
							else if (i === "hour") {
								params.currentWork = 'per_hours';
							}
							else if (i === "unemployed") {
								params.currentWork = 'unemployed';
							}
						}
					}
					for (var i in $scope.freelance) {
						if ($scope.freelance[i].selected) {
							if (i === "yes1") {
								params.selfEmployed = 'yes';
							}
							else if (i === "yes2") {
								params.selfEmployed = 'yes_cooperative';
							}
							else if (i === "no1") {
								params.selfEmployed = 'dont_want';
							}
							else if (i === "no2") {
								params.selfEmployed = 'could_be';
							}
						}
					}
					for (var i in $scope.vehicle) {
						if ($scope.vehicle[i].selected) {
							if (i === "bike") {
								params.transport.push(0);
							}
							else if (i === "moto") {
								params.transport.push(1);
							}
							else if (i === "car") {
								params.transport.push(2);
							}
							else if (i === "van") {
								params.transport.push(3);
							}
						}
					}
					for (var i in $scope.smartphone) {
						if ($scope.smartphone[i].selected) {
							if (i === "android") {
								params.smartPhone = 'android_new';
							}
							else if (i === "ios") {
								params.smartPhone = 'ios_new';
							}
							else if (i === "old") {
								params.smartPhone = 'old_version';
							}
							else if (i === "other") {
								params.smartPhone = 'other';
							}
						}
					}
					for (var i in $scope.currentDeliver) {
						if ($scope.currentDeliver[i].selected) {
							if (i === "yes-food") {
								params.areYouCourier = 'yes_food';
							}
							else if (i === "yes-traditional") {
								params.areYouCourier = 'yes_logistics';
							}
							else if (i === "yes") {
								params.areYouCourier = 'yes_other';
							}
							else if (i === "no") {
								params.areYouCourier = 'no';
							}
						}
					}
					for (var i in $scope.pastDeliver) {
						if ($scope.pastDeliver[i].selected) {
							if (i === "yes-food") {
								params.haveYouBeenCourier = 'yes_food';
							}
							else if (i === "yes-traditional") {
								params.haveYouBeenCourier = 'yes_logistics';
							}
							else if (i === "yes") {
								params.haveYouBeenCourier = 'yes_other';
							}
							else if (i === "no") {
								params.haveYouBeenCourier = 'no';
							}
						}
					}
					var array1, array2, array3;
					array1 = []; array2 = []; array3 = [];
					for (var i in $scope.weekday){
						if ($scope.weekday[i].selected) {
							if (i === "morning") {
								array1.push(0);
							}
							else if (i === "midday") {
								array1.push(1);
							}
							else if (i === "evening") {
								array1.push(2);
							}
							else if (i === "night") {
								array1.push(3);
							}
						}
					}
					for (var i in $scope.saturday){
						if ($scope.saturday[i].selected) {
							if (i === "morning") {
								array2.push(0);
							}
							else if (i === "midday") {
								array2.push(1);
							}
							else if (i === "evening") {
								array2.push(2);
							}
							else if (i === "night") {
								array2.push(3);
							}
						}
					}
					array3 = $scope.sunday.morning.selected ? [0] : [];
					params.availability = [array1, array2, array3];
					for (var i in $scope.howFindUs) {
						if ($scope.howFindUs[i].selected) {
							if (i === "mouth-ear") {
								params.hearAboutUs = 'mouth_ear';
							}
							else if (i === "social-networks") {
								params.hearAboutUs = 'social_net';
							}
							else if (i === "web") {
								params.hearAboutUs = 'web';
							}
                            else if (i === "job_today") {
                                params.hearAboutUs = 'job_today';
                            }
                            else if (i === "corner_job") {
                                params.hearAboutUs = 'corner_job';
                            }
							else if (i === "employment") {
								params.hearAboutUs = 'job_site';
							}
							else if (i === "others") {
								params.hearAboutUs = 'other';
							}
						}
					}
					$http.post(Configuration.apiUrl + '/drivers/form', params)
						.then(function successCallback(response) {
							console.log("SUCCESS");
							console.log(response);
							$scope.formSent = true;
							$scope.uploadingDriverForm = false;
						}, function errorCallback(data) {
							console.log("ERROR");
							console.log(data);
							$scope.formSent = false;
							$scope.uploadingDriverForm = false;
						});
				}
				else if (page > $scope.pages.total || page < 1) {
					console.log("ERROR ON SELECT PAGE: " + page);
				}
				else  {
					if ($scope.pages.current === 1) {
                        $window.fbq('track', 'DriverEnteredForm');
						toolsService.setFalse($scope.errors);
						if (!$scope.personalInfo.name.model) {
							$scope.errors.name = "driver-form.errors.name";
						}
						if (!$scope.personalInfo.surnames.model) {
							$scope.errors.surnames = "driver-form.errors.surnames";
						}
						var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
						if (!re.test($scope.personalInfo.email.model)) {
							$scope.errors.email = "driver-form.errors.email";
						}
						if ($scope.personalInfo.phone.model.length !== 9) {
							$scope.errors.phone = "driver-form.errors.phone";
						}
						if (!$scope.personalInfo.age.model) {
							$scope.errors.age = "driver-form.errors.age";
						}
					}
					if ($scope.pages.current !== 1 || (!$scope.errors.name && !$scope.errors.surnames && !$scope.errors.email && !$scope.errors.phone && !$scope.errors.age)) {
						$anchorScroll();
						$scope.pages.current = page;
						$scope.section = sections[page - 1];
						$scope.selectForm = selectForms[page - 1];
					}
				}
			}

			function someEmpty() {
				var allFill = true;
				if($scope.selectDistrict) {
					allFill = false;
					for(var i in $scope.districts) {
						allFill = allFill || $scope.districts[i].selected;
					}
				}
				else {
					if ($scope.pages.current === 1) {
						var fill = true;
						for (var i in $scope.personalInfo) {
							fill = fill && $scope.personalInfo[i].model;
						}
						allFill = allFill && fill;
					}
					else if ($scope.pages.current === 2) {
						allFill = allFill && $scope.imageProfile.base64;
					}
					if ($scope.pages.current === 4) {
						allFill = false;
					}
					for(var i in $scope.selectForm) {
						var fill = false;
						for (var j in $scope.selectForm[i].inputs) {
							fill = fill || $scope.selectForm[i].data[$scope.selectForm[i].inputs[j].id].selected;
						}
						if ($scope.pages.current === 4) {
							allFill = allFill || fill;
						}
						else {
							allFill = allFill && fill;
						}
					}
				}
				return !allFill || !$scope.districtSelected;
			}

			function chooseFunction(func, params, item, data) {
				func(item, data, params);
			}

			var validPhone = ""; var validAge = "";
			function validateSelector(id, data) {
				if (id === "phone") {
					if (data[id].model.length > 9) {
						data[id].model = validPhone;
					}
					else {
						if(!/^[0-9]*$/.test(data[id].model)) {
							data[id].model = validPhone;
						}
						else {
							validPhone = data[id].model;
						}
					}
				}
				else if (id === "age") {
					if(!/^[0-9]*$/.test(data[id].model)) {
						data[id].model = validAge;
					}
					else {
						validAge = data[id].model;
					}
				}
			}

			function doNothing() { }

			function selectRadio(item, array, params) {
				var multiple = params[0];
				if (!multiple || (item === "none" && $scope.pages.current === 3 && !array[item].selected)) {
					for(var i in array){
						if (i !== item) {
							array[i].selected = false;
						}
					}
				}
				if (item !== "none" && $scope.pages.current === 3 && array === $scope.vehicle) {
					array.none.selected = false;
				}
				array[item].selected = !array[item].selected || $scope.pages.current === 1;
			}

			function selectDistrictFunction(item, array, params){
				selectRadio(item, array, params);
				closeDistricts();
				$scope.districtSelected = array[item].placeholder;
			}

			function closeDistricts() {
				$timeout(function() {
					
					var cityKeys = Object.keys($scope.residence);
					for (var i = 0; i < cityKeys.length; ++i) {
						var actualCity = cityKeys[i];
						if ($scope.residence[actualCity].selected && !$scope.selectDistrict) {
							$scope.residence[actualCity].selected = true;//$scope.districtSelected;
						}
					}
					
					$scope.selectDistrict = selectDistrictForced;
					selectDistrictForced = false;
				}, 400);
			}

			function selectCity(item, array, params) {
				selectRadio(item, array, params);
				$scope.districtSelected = false;
				$timeout(function () {
					$scope.selectDistrict = selectDistrictForced = true;
					$anchorScroll();
          			$scope.city.districts = $scope.residence[item].districts;
				}, 300);
			}

			function checkImage() {
				$scope.errors.image = false;
				if ($scope.imageProfile.filetype.indexOf('image') < 0) {
					$scope.errors.image = "driver-form.errors.image-1";
					$scope.uploadingImage = $scope.imageProfile = false;
				}
				else if ($scope.imageProfile.filesize > 2097152) {
					$scope.errors.image = "driver-form.errors.image-2";
					$scope.uploadingImage = $scope.imageProfile = false;
				}
				else if ($scope.imageProfile.base64.indexOf(';base64,') > -1) {
					$scope.imageProfile.base64 = $scope.imageProfile.base64.substring($scope.imageProfile.base64.indexOf(';base64,') + 8);
				}
				console.log("TEST IMAGE", $scope.imageProfile);
			}


			/* --EXECUTION-- */

			$scope.pages.total = 6;
			$timeout(function () {
				$scope.selectPage(1);
			}, 0);
			$scope.$watch('imageProfile', function(newValue) {
				if (newValue) {
					console.log("WATCH");
					checkImage();
				}
			});
		});
})();
